import React from 'react';
import Divider from '@mui/material/Divider';
import { Button, Card, CardHeader, CardContent } from '@mui/material';
import Swal from 'sweetalert2';

import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, workWithLocalStorage } from '../../auxiliares/funciones';
import TrabajadorForm from './form/form';

export default function TrabajadorAlta(props) {
  const usuario = workWithLocalStorage('get', 'usuario', null);
  const Form = {
    nombre: '',
    puesto: 'TERAPEUTA',
    fechaAlta: new Date().toISOString().substring(0, 10),
    fechaBaja: '',
    activo: 1
  };

  const [trabajador, setTrabajador] = React.useState(Form);
  const [cargado, setCargado] = React.useState(false);
  const [id, setId] = React.useState(props.params && props.params.id ? props.params.id : '0');

  React.useEffect(() => {
    async function cargaInicial() {
      if (!cargado) {
        if (id !== '0') {
          const bodyJson = JSON.stringify(buildBody(usuario.token, { id }));
          fetch(`${CONFIG.api}trabajador/detalle`, {
            method: 'POST',
            body: bodyJson,
            headers: { 'Content-Type': 'application/json' }
          })
            .then((res) => res.json())
            .then((result) => {
              if (result.error === 0 && !isEmpty(result.data)) {
                setTrabajador(result.data);
              }
              if (props.showLoader) props.showLoader(false);
              setCargado(true);
            });
        } else {
          if (props.showLoader) props.showLoader(false);
          setCargado(true);
        }
      }
    }
    cargaInicial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargado]);

  const Grabar = () => {
    const valido = trabajador.nombre && trabajador.nombre.trim() !== '' && trabajador.puesto && trabajador.puesto.trim() !== '';
    if (valido) {
      if (props.showLoader) props.showLoader(true);
      const bodyJson = JSON.stringify(buildBody(usuario.token, trabajador));
      fetch(`${CONFIG.api}trabajador/detalle`, {
        method: 'PUT',
        body: bodyJson,
        headers: { 'Content-Type': 'application/json' }
      })
        .then((res) => res.json())
        .then((result) => {
          let msg = 'Trabajador/a grabado!';
          if (result.error === 0) {
            setId(result.data.id);
            if (props.index && document.getElementById(`simple-tab-${props.index}`)) {
              document.getElementById(`simple-tab-${props.index}`).getElementsByTagName('span')[0].textContent = `Editar Trabajador/a #${result.data.id} `;
            }
            setCargado(false);
          } else {
            if (props.showLoader) props.showLoader(false);
            msg = result.errorMessage;
          }
          Swal.fire({
            title: msg,
            buttons: [{ label: 'Ok' }]
          });
        })
        .catch((err) => {
          if (props.showLoader) props.showLoader(false);
          Swal.fire({
            title: `Error: ${err.message}`,
            buttons: [{ label: 'Ok' }]
          });
        });
    } else {
      Swal.fire({
        title: 'Revisa los campos con * (Nombre y Puesto obligatorios)',
        buttons: [{ label: 'Ok' }]
      });
    }
  };

  const Nuevo = () => {
    setTrabajador(Form);
    setId('0');
    if (props.index && document.getElementById(`simple-tab-${props.index}`)) {
      document.getElementById(`simple-tab-${props.index}`).getElementsByTagName('span')[0].textContent = 'Alta Trabajador/a ';
    }
  };

  const actualizaCampo = (input) => {
    const nombre = input.target.name;
    const valor = input.target.value;
    setTrabajador({ ...trabajador, [nombre]: valor });
  };

  const Activar = () => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'trabajador',
      activo: 1,
      id: trabajador.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Trabajador/a activado!';
        if (result.error === 0) {
          setCargado(false);
        } else {
          if (props.showLoader) props.showLoader(false);
          msg = result.errorMessage;
        }
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  const Borrar = () => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'trabajador',
      activo: 0,
      id: trabajador.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Trabajador/a desactivado!';
        if (result.error === 0) {
          setCargado(false);
        } else {
          if (props.showLoader) props.showLoader(false);
          msg = result.errorMessage;
        }
        if (props.showLoader) props.showLoader(false);
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  return (
    <Page title="Alta Trabajador">
      <Card sx={{ maxWidth: '100% !important' }}>
        <CardHeader
          action={
            <>
              <Button
                variant="contained"
                color="success"
                sx={{ color: 'white', marginRight: '15px' }}
                to="#"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => Grabar()}
              >
                Grabar
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ color: 'white', marginRight: '15px' }}
                to="#"
                startIcon={<Iconify icon="eva:edit-outline" />}
                onClick={() => Nuevo()}
              >
                Nuevo
              </Button>
              {trabajador.id &&
                (trabajador.activo === 1 ? (
                  <Button
                    variant="contained"
                    color="error"
                    sx={{ color: 'white' }}
                    to="#"
                    startIcon={<Iconify icon="eva:trash-2-outline" />}
                    onClick={() => Borrar()}
                  >
                    Borrar
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="warning"
                    sx={{ color: 'white' }}
                    to="#"
                    startIcon={<Iconify icon="eva:refresh-fill" />}
                    onClick={() => Activar()}
                  >
                    Activar
                  </Button>
                ))}
            </>
          }
          title={id === '0' ? 'Alta Trabajador/a' : `Editar Trabajador/a #${id}`}
        />
        <Divider style={{ margin: '15px' }} />
        <CardContent>
          {cargado && (
            <TrabajadorForm
              showLoader={props.showLoader}
              trabajador={trabajador}
              actualizaCampo={actualizaCampo}
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
}
